import BrandConfigStore from "../../../services/config/BrandConfigStore";
import SessionStore from "../../../services/session/SessionStore";
import * as mobx from 'mobx'
import {installScript, onceScriptLoaded} from "./scriptUtil";

import variables from "../../../../src/components/bootstrap4/includes/_core-variables.scss"

function hide() {
  /* Remove Zendesk from non-login pages*/

  for (let selector of ['#ze-snippet', '.zopim', '.zEWidget-launcher', '.zEWidget-webWidget']) {
    for (let elem of document.querySelectorAll(selector)) {
      elem.parentElement && elem.parentElement.removeChild(elem)
    }
  }
}

const shouldShowHelpCenter = (brandConfigStore) => {
  return !!brandConfigStore.brandConfig
    && !brandConfigStore.brandConfig.restrictions.hideHelpCenter
    && !brandConfigStore.isApproximate
}

const isNewLayout = (sessionStore) => {
  return sessionStore.userPreferences !== undefined
    && BrandConfigStore.brandConfig.restrictions.hideNewUiOptIn === false
}

const isOldLayout = (sessionStore) => {
  return sessionStore.userPreferences !== undefined
    && BrandConfigStore.brandConfig.restrictions.hideNewUiOptIn !== false
}

// We use the default ZenDesk Help button for the old layout
function shouldDisplayHelpCenterForOldLayout() {
  return shouldShowHelpCenter(BrandConfigStore) && isOldLayout(SessionStore)
}

// In the new layout, we place a custom help button in the header nav
function shouldDisplayHelpCenterForNewLayout() {
  return shouldShowHelpCenter(BrandConfigStore)
    && isNewLayout(SessionStore)
}

let oldLayoutDisposer
let newLayoutDisposer
export function install() {
  newLayoutDisposer = mobx.reaction(
    () => shouldDisplayHelpCenterForNewLayout(),
    display => {
      if (display) {
        var s = installScript('https://static.zdassets.com/ekr/snippet.js?key=37d33c51-706f-4b13-8d13-f5a6f8509b6d')
        s.id = "ze-snippet"

        onceScriptLoaded(s, () => {
          // Make sure ZenDesk has loaded all of its dependencies
          return !!window.zE.hide
        } ).then(() => {

          window.helpCenterOpen = false;
          window.showHelpCenter = () => {window.helpCenterOpen = true; zE.showIPMWidget()}
          window.hideHelpCenter = () => {window.helpCenterOpen = false;  zE.hideIPMWidget()}

          zE(() => {
            zE('webWidget:on', 'close', function () {
              window.helpCenterOpen = false;
            });
            $zopim(() => {
              // Hide the default ZenDesk help center button
              const launcher = document.getElementById('launcher');
              if (launcher) {
                launcher.setAttribute('hidden', true);
              }
            });
          })
        })

        // const header = document.querySelector("div.foldy-layout-main-header-top-wrapper")
        // const headerHeight = !!header ? header.clientHeight : 0

        const headerHeight = parseInt(variables.headerHeight.replace("px", ""))
        // We need to lower the offset a bit to make the widget look better
        const additionalHeaderOffset = -6;

        const widgetPlacement = BrandConfigStore?.brandConfig?.restrictions?.hideApplicationBar ? {
          offset: {
            horizontal: `calc(${parseInt(variables.sidebarWidth.replace("px", ""))}px + ${variables.cardPaddingX})`,
            vertical: variables.cardPaddingY
          },
          position: { horizontal: 'left', vertical: 'bottom' }
        } : {
          offset: {
            horizontal: '-7px',
            vertical: ('' + (headerHeight + additionalHeaderOffset) + 'px')
          },
          position: { horizontal: 'right', vertical: 'top' }
        }

        window.zESettings = {
          webWidget: {
            ...widgetPlacement
          }
        };
      } else {
        hide()
      }
    }
  )

  oldLayoutDisposer = mobx.reaction(
    () => shouldDisplayHelpCenterForOldLayout(),
    display => {
      if (display) {
        // Displays ZenDesk widget in default position (as of this time, bottom left)
        var s = installScript('https://static.zdassets.com/ekr/snippet.js?key=37d33c51-706f-4b13-8d13-f5a6f8509b6d')
        s.id = "ze-snippet"
      } else {
        hide()
      }
    }
  )
}

export function uninstall() {
  hide()
  // Hide the help center for the old and new layouts
  newLayoutDisposer()
  oldLayoutDisposer()
}